export default "__VITE_ASSET__DZTZmNW5__"